import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import RoleService from "@/core/services/role.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const EXTERNAL_LOGIN = "externalLogin";
export const LOGIN_EXECUTIVE = "loginExecutive";
export const LOGOUT = "logout";
export const UPDATE_AUTH = "updateAuth";
export const UPDATE_INFO = "updateInfo";
export const UPDATE_INFO_PASSWORD = "updateInfoPassword";
export const REDIRECT_OR_LOGOUT = "redirectOrLogout";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const REDIRECT_CORREDORES = "redirectCorredores";

let externalAccess = false

//const url = 'https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi'
//const url = 'https://localhost:44340'
const state = {
  errors: null,
  user: {},
  image: "",
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  [EXTERNAL_LOGIN](context, token) {
    return new Promise(resolve => {
      ApiService.setToken(token);
      ApiService.get({ action: "/facturacioncomisionapi/api/OAuth/v1/me" })
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
          externalAccess = true
          //   console.log('externalAccess: ', externalAccess)
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"]);
        });
    });
  },

  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      ApiService.post({ action: "/facturacioncomisionapi/api/OAuth/v1/usuario/autenticar" }, credentials)
      // Dev
    //   ApiService.post({ action: "/api/OAuth/v1/usuario/autenticar" }, credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
          externalAccess = false
          //   console.log('externalAccess: ', externalAccess)
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"]);//response.data.errors);
        });
    });
  },
  [LOGIN_EXECUTIVE](context, credentials) {
    return new Promise(resolve => {
      ApiService.post({ action: "/facturacioncomisionapi/api/OAuth/v1/usuario/autenticar" }, credentials)
        .then(({ data }) => {
          //console.log(('retorna ' + data);
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"]);//response.data.errors);
        });
    });
  },

  [UPDATE_AUTH](context, codigoEmpresa) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({ action: `/facturacioncomisionapi/api/OAuth/v1/acceso/update` }, { "codigoEmpresa": codigoEmpresa })
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"]);//response.data.errors);
          reject(response)
        });
    });
  },
  [UPDATE_INFO](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({ action: `/facturacioncomisionapi/api/OAuth/v1/acceso/updateInfo` }, user)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"]);//response.data.errors);
          reject(response)
        });
    });
  },
  [UPDATE_INFO_PASSWORD](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.put({ action: `/facturacioncomisionapi/api/OAuth/v1/acceso/cambiarClave` }, user)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"]);//response.data.errors);
          reject(response)
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },

  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get({ action: "/facturacioncomisionapi/api/OAuth/v1/Me" })
      // Dev
    //   ApiService.get({ action: "/api/OAuth/v1/Me" })
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, 'caida');//response.data);
          context.commit(PURGE_AUTH);
        });
    } else {
      context.commit(PURGE_AUTH);
    }
  },

  [REDIRECT_OR_LOGOUT](context) {
    // console.log('externalAccess: ', externalAccess)
    if (externalAccess) {
      context.commit(REDIRECT_CORREDORES);
    } else {
      context.commit(PURGE_AUTH);
    }
  },
};

const mutations = {

  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    ////console.log(('token' + state.user.token);
    JwtService.saveToken(state.user.token);
    RoleService.saveRole(state.user.codigoRol);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
    RoleService.destroyRole();
  },
  [REDIRECT_CORREDORES](state) {
    // console.log('ON REDIRECT_CORREDORES')
    state.isAuthenticated = true;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
    RoleService.destroyRole();
    externalAccess = false;
    window.location.href = "https://webcorredores.contemporaseguros.com"
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
